"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment = require("moment");
function selectedRegion(state) {
    var region = lodash_1.find(state.availableRegions, {
        id: state.params.regionID,
    });
    return region ? region : { id: '', name: 'Bitte auswählen' };
}
exports.selectedRegion = selectedRegion;
function selectedAirport(state) {
    var airport = lodash_1.find(state.availableAirports, {
        id: state.params.departureAirport,
    });
    return airport ? airport : { id: 'all', name: 'Abflughafen' };
}
exports.selectedAirport = selectedAirport;
function selectedShip(state) {
    var ship = lodash_1.find(state.availableShips, {
        name: state.params.ship,
    });
    return ship ? ship : { id: 'all', name: 'Schiff' };
}
exports.selectedShip = selectedShip;
function selectedTravelDuration(state) {
    var duration = lodash_1.find(state.availableDurations, {
        id: parseInt(state.params.travelDuration),
    });
    return duration ? duration : { id: -1, name: 'Reisedauer', from: 0, to: 0 };
}
exports.selectedTravelDuration = selectedTravelDuration;
function selectedExtraFilter(state) {
    var foundExtraFilters = lodash_1.find(state.availableExtraFilters, {
        id: state.params.extraFilter,
    });
    return foundExtraFilters
        ? foundExtraFilters
        : { id: 'all', name: 'Erweitert' };
}
exports.selectedExtraFilter = selectedExtraFilter;
function paramsTouched(state) {
    return state.paramsTouched;
}
exports.paramsTouched = paramsTouched;
function searchButtonTouched(state) {
    return state.searchButtonTouched;
}
exports.searchButtonTouched = searchButtonTouched;
function extraFilters(state) {
    return state.availableExtraFilters;
}
exports.extraFilters = extraFilters;
function regions(state) {
    var blackList = ['VRSE', 'VRSP'];
    var applyBlackList = function (region) { return blackList.indexOf(region.id) === -1; };
    var droppedRegions = lodash_1.filter(state.availableRegions, applyBlackList);
    var filteredRegions = lodash_1.sortBy(droppedRegions, 'name');
    /* const routes = results(state)
    let regionIds = []
    each(routes, route => {
      regionIds = uniq(concat(regionIds, route.regionIDs))
    })
    const applyAvailFilter = region => regionIds.indexOf(region.id) !== -1
    filteredRegions = filter(filteredRegions, applyAvailFilter) */
    return lodash_1.concat([{ id: 'ALL', name: 'Alle Regionen' }], filteredRegions);
}
exports.regions = regions;
function airports(state) {
    return lodash_1.sortBy(state.availableAirports, 'name');
}
exports.airports = airports;
function ships(state) {
    return lodash_1.sortBy(state.availableShips, 'name');
}
exports.ships = ships;
function flights(state) {
    return state.flights;
}
exports.flights = flights;
function durations(state) {
    return lodash_1.sortBy(state.availableDurations, 'id');
}
exports.durations = durations;
function params(state) {
    return state.params;
}
exports.params = params;
function displayPaxText(state) {
    return lodash_1.compact([
        calcPaxText(state.params.adults, 'Erwachsener', 'Erwachsene'),
        calcPaxText(state.params.juveniles, 'Jugendlicher', 'Jugendliche'),
        calcPaxText(state.params.children, 'Kind', 'Kinder'),
    ]).join(' ');
}
exports.displayPaxText = displayPaxText;
function displayPaxTextShort(state) {
    return lodash_1.compact([
        calcPaxText(state.params.adults, 'Erw.', 'Erw.'),
        calcPaxText(state.params.juveniles, 'Jugdl.', 'Jugendl.'),
        calcPaxText(state.params.children, 'Kind', 'Kinder'),
    ]).join(' ');
}
exports.displayPaxTextShort = displayPaxTextShort;
function filteredRoutes(state) {
    if ((state.params.regionID === null || state.params.regionID === 'ALL') &&
        state.params.travelDuration === null) {
        return state.searchResults;
    }
    if (state.params.regionID !== null && state.params.travelDuration === null) {
        return lodash_1.filter(state.searchResults, function (route) {
            return lodash_1.indexOf(route.regionIDs, state.params.regionID) !== -1;
        });
    }
    if ((state.params.regionID === null || state.params.regionID === 'ALL') &&
        state.params.travelDuration !== null) {
        var duration_1 = selectedTravelDuration(state);
        return lodash_1.filter(state.searchResults, function (route) {
            return route.duration <= duration_1.to && route.duration >= duration_1.from;
        });
    }
    if (state.params.regionID !== null && state.params.travelDuration !== null) {
        var duration_2 = selectedTravelDuration(state);
        return lodash_1.filter(state.searchResults, function (route) {
            return (lodash_1.indexOf(route.regionIDs, state.params.regionID) !== -1 &&
                route.duration <= duration_2.to &&
                route.duration >= duration_2.from);
        });
    }
    return state.searchResults;
}
exports.filteredRoutes = filteredRoutes;
function backgroundImages(state) {
    return state.backgroundImages;
}
exports.backgroundImages = backgroundImages;
function results(state) {
    var paxKey = "" + state.params.adults + state.params.juveniles + state.params.children;
    var timeFrom = state.params.timeFrom;
    var timeTo = state.params.timeTo;
    var routes = deepCopyObject(filteredRoutes(state));
    if (state.params.departureAirport) {
        var airport = state.params.departureAirport;
        var flightRes_1 = flights(state) ? flights(state)[airport] : null;
        if (flightRes_1) {
            var flightPaxKey_1 = "A" + state.params.adults + "J" + state.params.juveniles + "C" + state.params.children;
            routes = lodash_1.map(routes, function (route) {
                route.cruises = lodash_1.map(route.cruises, function (cruise) {
                    if (!cruise.prices[paxKey] || !cruise.prices[paxKey].length) {
                        return;
                    }
                    cruise.priceInfo = cruise.prices[paxKey];
                    cruise.prices[paxKey] = lodash_1.map(cruise.prices[paxKey], function (priceInfo) {
                        if (!flightRes_1[cruise.cruiseID] ||
                            !flightRes_1[cruise.cruiseID][flightPaxKey_1] ||
                            !(flightRes_1[cruise.cruiseID][flightPaxKey_1][priceInfo.priceModel] >= 0)) {
                            return;
                        }
                        if (priceInfo.flight) {
                            cruise['mandatoryFlight'] = true;
                        }
                        else {
                            cruise['mandatoryFlight'] = false;
                        }
                        var cruisePrice = priceInfo.amount;
                        var flightPrice = flightRes_1[cruise.cruiseID][flightPaxKey_1][priceInfo.priceModel];
                        priceInfo.amount = cruisePrice + flightPrice;
                        priceInfo.flight = true;
                        return priceInfo;
                    });
                    cruise.prices[paxKey] = lodash_1.compact(cruise.prices[paxKey]);
                    if (!cruise.prices[paxKey].length) {
                        return;
                    }
                    return cruise;
                });
                route.cruises = lodash_1.compact(route.cruises);
                return route;
            });
        }
    }
    routes = lodash_1.map(routes, function (route) {
        route.cruises = lodash_1.filter(route.cruises, function (cruise) {
            if (state.params.ship && cruise.ship !== state.params.ship) {
                return false;
            }
            if (!cruise.prices[paxKey]) {
                return false;
            }
            if (state.params.timeFrom && state.params.timeTo) {
                if (!moment(cruise.start, 'DD.MM.YYYY').isBetween(timeFrom, timeTo, null, '[]') ||
                    !moment(cruise.end, 'DD.MM.YYYY').isBetween(timeFrom, timeTo, null, '[]')) {
                    return false;
                }
            }
            if (state.params.departureAirport &&
                lodash_1.indexOf(cruise.airports, state.params.departureAirport) === -1) {
                return false;
            }
            return true;
        });
        route.cruises = lodash_1.map(route.cruises, function (cruise) {
            cruise.priceInfo = lodash_1.minBy(cruise.prices[paxKey], 'amount');
            if (!cruise.priceInfo) {
                // console.log('Fix THIS', cruise)
                return;
            }
            cruise.priceModel = cruise.priceInfo.priceModel;
            if (cruise.priceModel === 'IND') {
                cruise.priceModel = 'PREMIUM';
            }
            /* cruise.earlyBird = find(cruise.priceInfo.surcharges, surcharge => {
              return surcharge.type === 'EB' || surcharge.type === 'EBP'
            }) */
            if (!state.params.departureAirport) {
                cruise.price = cruise.priceInfo.amount;
            }
            else {
                cruise.price = cruise.priceInfo.amount;
            }
            cruise.flight = cruise.priceInfo.flight;
            return cruise;
        });
        route.cruises = lodash_1.compact(route.cruises);
        if (route.cruises.length) {
            route.cheapestCruiseIndex = lodash_1.minBy(route.cruises, 'price').price;
            route.cheapestCruiseIndex = lodash_1.findIndex(route.cruises, {
                price: route.cheapestCruiseIndex,
            });
        }
        return route;
    });
    // console.log('routes', routes)
    routes = lodash_1.filter(routes, function (route) {
        return route.cruises.length;
    });
    // extra filters...
    if (state.params.extraFilter === null &&
        state.params.departureAirport === null) {
        routes = lodash_1.sortBy(routes, function (route) {
            return route.cruises[route.cheapestCruiseIndex].price;
        });
        return routes;
    }
    switch (state.params.extraFilter) {
        case 'SEL':
            routes = lodash_1.filter(routes, function (route) {
                return lodash_1.indexOf(route.regionIDs, 'VRSE') !== -1;
            });
            break;
        case 'PAU':
            routes = lodash_1.map(routes, function (route) {
                route.cruises = lodash_1.filter(route.cruises, function (cruise) {
                    return (lodash_1.findIndex(cruise.prices[paxKey], function (price) {
                        return price.priceModel === 'PAUSCHAL';
                    }) !== -1);
                });
                route.cruises = lodash_1.map(route.cruises, function (cruise) {
                    var index = lodash_1.findIndex(cruise.prices[paxKey], function (price) {
                        if (price.priceModel === 'PAUSCHAL') {
                            return true;
                        }
                    });
                    cruise.priceInfo = cruise.prices[paxKey][index];
                    cruise.priceModel = cruise.priceInfo.priceModel;
                    if (!state.params.departureAirport) {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    else {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    cruise.flight = cruise.priceInfo.flight;
                    /* cruise.earlyBird = find(cruise.priceInfo.surcharges, surcharge => {
                      return surcharge.type === 'EB' || surcharge.type === 'EBP'
                    }) */
                    return cruise;
                });
                // post processing
                if (route.cruises.length) {
                    route.cheapestCruiseIndex = lodash_1.minBy(route.cruises, 'price').price;
                    route.cheapestCruiseIndex = lodash_1.findIndex(route.cruises, {
                        price: route.cheapestCruiseIndex,
                    });
                }
                return route;
            });
            break;
        case 'VAR':
            routes = lodash_1.map(routes, function (route) {
                route.cruises = lodash_1.filter(route.cruises, function (cruise) {
                    return (lodash_1.findIndex(cruise.prices[paxKey], function (price) {
                        return price.priceModel === 'VARIO';
                    }) !== -1);
                });
                route.cruises = lodash_1.map(route.cruises, function (cruise) {
                    var index = lodash_1.findIndex(cruise.prices[paxKey], function (price) {
                        if (price.priceModel === 'VARIO') {
                            return true;
                        }
                    });
                    cruise.priceInfo = cruise.prices[paxKey][index];
                    cruise.priceModel = cruise.priceInfo.priceModel;
                    if (!state.params.departureAirport) {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    else {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    cruise.flight = cruise.priceInfo.flight;
                    /* cruise.earlyBird = find(cruise.priceInfo.surcharges, surcharge => {
                      return surcharge.type === 'EB' || surcharge.type === 'EBP'
                    }) */
                    return cruise;
                });
                // post processing
                if (route.cruises.length) {
                    route.cheapestCruiseIndex = lodash_1.minBy(route.cruises, 'price').price;
                    route.cheapestCruiseIndex = lodash_1.findIndex(route.cruises, {
                        price: route.cheapestCruiseIndex,
                    });
                }
                return route;
            });
            break;
        case 'IND':
            routes = lodash_1.map(routes, function (route) {
                route.cruises = lodash_1.filter(route.cruises, function (cruise) {
                    return (lodash_1.findIndex(cruise.prices[paxKey], function (price) {
                        return price.priceModel === 'IND';
                    }) !== -1);
                });
                route.cruises = lodash_1.map(route.cruises, function (cruise) {
                    var index = lodash_1.findIndex(cruise.prices[paxKey], function (price) {
                        if (price.priceModel === 'IND') {
                            return true;
                        }
                    });
                    cruise.priceInfo = cruise.prices[paxKey][index];
                    cruise.priceModel = 'PREMIUM';
                    if (!state.params.departureAirport) {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    else {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    cruise.flight = cruise.priceInfo.flight;
                    /* cruise.earlyBird = find(cruise.priceInfo.surcharges, surcharge => {
                      return surcharge.type === 'EB' || surcharge.type === 'EBP'
                    }) */
                    return cruise;
                });
                // post processing
                if (route.cruises.length) {
                    route.cheapestCruiseIndex = lodash_1.minBy(route.cruises, 'price').price;
                    route.cheapestCruiseIndex = lodash_1.findIndex(route.cruises, {
                        price: route.cheapestCruiseIndex,
                    });
                }
                return route;
            });
            break;
        case 'FR':// EB und EBP
            routes = lodash_1.map(routes, function (route) {
                route.cruises = lodash_1.filter(route.cruises, function (cruise) {
                    return (lodash_1.findIndex(cruise.prices[paxKey], function (price) {
                        if (price.surcharges && price.surcharges.length === 0) {
                            return false;
                        }
                        return (lodash_1.findIndex(price.surcharges, function (surcharge) {
                            return surcharge.type === 'EB' || surcharge.type === 'EBP';
                        }) !== -1);
                    }) !== -1);
                });
                route.cruises = lodash_1.map(route.cruises, function (cruise) {
                    var index = lodash_1.findIndex(cruise.prices[paxKey], function (price) {
                        if (price.surcharges && price.surcharges.length === 0) {
                            return false;
                        }
                        return (lodash_1.findIndex(price.surcharges, function (surcharge) {
                            return surcharge.type === 'EB' || surcharge.type === 'EBP';
                        }) !== -1);
                    });
                    cruise.priceInfo = cruise.prices[paxKey][index];
                    cruise.priceModel = cruise.priceInfo.priceModel;
                    if (cruise.priceModel === 'IND') {
                        cruise.priceModel = 'PREMIUM';
                    }
                    if (!state.params.departureAirport) {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    else {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    cruise.flight = cruise.priceInfo.flight;
                    /* cruise.earlyBird = find(cruise.priceInfo.surcharges, surcharge => {
                      return surcharge.type === 'EB' || surcharge.type === 'EBP'
                    }) */
                    return cruise;
                });
                // post processing
                if (route.cruises.length) {
                    route.cheapestCruiseIndex = lodash_1.minBy(route.cruises, 'price').price;
                    route.cheapestCruiseIndex = lodash_1.findIndex(route.cruises, {
                        price: route.cheapestCruiseIndex,
                    });
                }
                return route;
            });
            break;
        case 'ACT':// BGH
            routes = lodash_1.map(routes, function (route) {
                route.cruises = lodash_1.filter(route.cruises, function (cruise) {
                    return (lodash_1.findIndex(cruise.prices[paxKey], function (price) {
                        if (price.surcharges && price.surcharges.length === 0) {
                            return false;
                        }
                        return (lodash_1.findIndex(price.surcharges, function (surcharge) {
                            return surcharge.type === 'BGH';
                        }) !== -1 &&
                            (cruise.priceModel === 'IND' ||
                                cruise.priceModel === 'PREMIUM' ||
                                cruise.priceModel === 'VARIO'));
                    }) !== -1);
                });
                route.cruises = lodash_1.map(route.cruises, function (cruise) {
                    var index = lodash_1.findIndex(cruise.prices[paxKey], function (price) {
                        if (price.surcharges && price.surcharges.length === 0) {
                            return false;
                        }
                        return (lodash_1.findIndex(price.surcharges, function (surcharge) {
                            return surcharge.type === 'BGH';
                        }) !== -1);
                    });
                    cruise.priceInfo = cruise.prices[paxKey][index];
                    cruise.priceModel = cruise.priceInfo.priceModel;
                    if (cruise.priceModel === 'IND') {
                        cruise.priceModel = 'PREMIUM';
                    }
                    if (!state.params.departureAirport) {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    else {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    cruise.flight = cruise.priceInfo.flight;
                    /* cruise.earlyBird = find(cruise.priceInfo.surcharges, surcharge => {
                      return surcharge.type === 'EB' || surcharge.type === 'EBP'
                    }) */
                    return cruise;
                });
                // post processing
                if (route.cruises.length) {
                    route.cheapestCruiseIndex = lodash_1.minBy(route.cruises, 'price').price;
                    route.cheapestCruiseIndex = lodash_1.findIndex(route.cruises, {
                        price: route.cheapestCruiseIndex,
                    });
                }
                return route;
            });
            break;
        case 'AIR':// mandatoryFlight beim Price
            routes = lodash_1.map(routes, function (route) {
                if (state.params.departureAirport) {
                    route.cruises = lodash_1.filter(route.cruises, function (cruise) {
                        return cruise.mandatoryFlight;
                    });
                }
                else {
                    route.cruises = lodash_1.filter(route.cruises, function (cruise) {
                        return (lodash_1.findIndex(cruise.prices[paxKey], function (price) {
                            return price.flight;
                        }) !== -1);
                    });
                }
                route.cruises = lodash_1.map(route.cruises, function (cruise) {
                    // minBy(cruise.prices[paxKey], 'amount')
                    cruise.priceInfo = lodash_1.minBy(lodash_1.filter(cruise.prices[paxKey], function (price) { return !!price.flight; }), 'amount');
                    cruise.priceModel = cruise.priceInfo.priceModel;
                    if (cruise.priceModel === 'IND') {
                        cruise.priceModel = 'PREMIUM';
                    }
                    if (!state.params.departureAirport) {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    else {
                        cruise.price = cruise.priceInfo.amount;
                    }
                    cruise.flight = cruise.priceInfo.flight;
                    /* cruise.earlyBird = find(cruise.priceInfo.surcharges, surcharge => {
                      return surcharge.type === 'EB' || surcharge.type === 'EBP'
                    }) */
                    return cruise;
                });
                // post processing
                if (route.cruises.length) {
                    route.cheapestCruiseIndex = lodash_1.minBy(route.cruises, 'price').price;
                    route.cheapestCruiseIndex = lodash_1.findIndex(route.cruises, {
                        price: route.cheapestCruiseIndex,
                    });
                }
                return route;
            });
            break;
        case 'DE':
            routes = lodash_1.filter(routes, function (route) {
                return (route.startHabour === 'Kiel' ||
                    route.startHabour === 'Hamburg' ||
                    route.startHabour === 'Warnemünde' ||
                    route.startHabour === 'Bremerhaven');
            });
            break;
    }
    routes = lodash_1.filter(routes, function (route) {
        return route.cruises.length;
    });
    // filter routes for PricePlanCampaigns
    var reduceFilter = state.reducedResultsFilter;
    if (reduceFilter && reduceFilter.length > 0) {
        routes = lodash_1.filter(routes, function (route) {
            return lodash_1.find(reduceFilter, { routeName: route.name });
        });
        routes = lodash_1.filter(routes, function (route) {
            return route.regionIDs.indexOf(state.params.regionID) > -1;
        });
        routes = lodash_1.map(routes, function (route) {
            var filterRoute = lodash_1.find(reduceFilter, {
                routeName: route.name,
            });
            var filteredCruises = lodash_1.filter(route.cruises, function (cruise) {
                var filterCruise = lodash_1.find(filterRoute.cruisesPricePlan, {
                    cruiseId: cruise.cruiseID,
                });
                if (filterCruise) {
                    // console.log('filterCruise', filterCruise)
                    var flight = filterCruise.flightInclusive;
                    cruise.flight = flight;
                    cruise.flightConnection = filterCruise.flightConnection;
                    cruise.price =
                        flight && filterCruise.price ? filterCruise.price : cruise.price;
                }
                return filterCruise !== undefined;
            });
            route.cruises = filteredCruises;
            if (route.cruises.length) {
                route.cheapestCruiseIndex = lodash_1.minBy(route.cruises, 'price').price;
                route.cheapestCruiseIndex = lodash_1.findIndex(route.cruises, {
                    price: route.cheapestCruiseIndex,
                });
            }
            return route;
        });
    }
    // end filter
    routes = lodash_1.sortBy(routes, function (route) {
        if (!route.cruises.length) {
            return;
        }
        var cruisesOk = route.cruises;
        var cheapestIdx = route.cheapestCruiseIndex;
        var chespestCruise = cruisesOk ? route.cruises[cheapestIdx] : undefined;
        return chespestCruise ? chespestCruise.price : 0;
    });
    //  return deepFreeze(routes)
    return routes;
}
exports.results = results;
// export everything compliant to the vuex specification for getters
exports.default = {
    selectedRegion: selectedRegion,
    selectedAirport: selectedAirport,
    selectedShip: selectedShip,
    selectedTravelDuration: selectedTravelDuration,
    selectedExtraFilter: selectedExtraFilter,
    paramsTouched: paramsTouched,
    searchButtonTouched: searchButtonTouched,
    extraFilters: extraFilters,
    regions: regions,
    airports: airports,
    ships: ships,
    flights: flights,
    durations: durations,
    params: params,
    displayPaxText: displayPaxText,
    displayPaxTextShort: displayPaxTextShort,
    filteredRoutes: filteredRoutes,
    backgroundImages: backgroundImages,
    results: results,
};
function calcPaxText(number, singular, plural) {
    if (number === '0' || number === 0) {
        return null;
    }
    return number
        ? number === 1
            ? number + " " + singular
            : number + " " + plural
        : null;
}
function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o.hasOwnProperty(prop) &&
            o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
var deepCopyObject = function (o) {
    var r, i, l;
    if (typeof o !== 'object')
        return o;
    if (!o)
        return o;
    if (o.constructor === Array) {
        r = [];
        l = o.length;
        for (i = 0; i < l; i++)
            r[i] = deepCopyObject(o[i]);
        return r;
    }
    var rr = {};
    for (i in o)
        rr[i] = deepCopyObject(o[i]);
    return rr;
};
//# sourceMappingURL=getters.js.map